export default {
  name: 'WaiterServiceCommon',

  computed: {
    waiterServiceActive() {
      return this.AppWaiterService?.Active ?? false
    },

    waiterServiceCharge() {
      return this.AppWaiterService?.Charge ?? null
    },

    waiterServiceChargePrice() {
      return this.AppWaiterService?.Charge?.Price ?? 0
    },

    waiterServiceExtraFields() {
      return this.AppWaiterService?.ExtraFields ?? null
    }
  },

  methods: {}
}
